import { Mail } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Spinner } from '@/components/ui/spinner';
import { useConvitesPendentes, useResponderConvite } from '@/hooks/useConvitesPendentes';
import { ROLE_LABELS } from '@/pages/escritorios/papeis';

/**
 * O aviso dos convites que a pessoa recebeu e ainda não respondeu, com aceitar e recusar ali
 * mesmo — sem depender do link do e-mail. Some quando não há convite.
 */
export function ConvitesPendentes() {
  const { data: convites } = useConvitesPendentes();
  const { aceitar, recusar } = useResponderConvite();
  if (!convites || convites.length === 0) return null;

  return (
    <Card className="border-primary/40 bg-primary/5">
      <CardContent className="p-4">
        <div className="mb-2 flex items-center gap-2">
          <Mail className="h-4 w-4 text-primary" aria-hidden="true" />
          <h3 className="text-sm font-semibold">
            {convites.length === 1 ? 'Você tem um convite para um escritório' : 'Você tem convites para escritórios'}
          </h3>
        </div>
        <ul className="divide-y">
          {convites.map((c) => {
            const emAndamento =
              (aceitar.isPending && aceitar.variables === c.id) || (recusar.isPending && recusar.variables?.id === c.id);
            return (
              <li key={c.id} className="flex flex-wrap items-center justify-between gap-2 py-2.5">
                <p className="min-w-0 break-words text-sm">
                  <strong>{c.escritorio_nome}</strong>
                  <span className="text-muted-foreground">
                    {' '}
                    — {c.convidado_por_nome ? `${c.convidado_por_nome} convidou você` : 'convite'} como{' '}
                    {(ROLE_LABELS[c.role] ?? c.role).toLowerCase()}
                  </span>
                </p>
                <span className="flex shrink-0 gap-2">
                  <Button
                    size="sm"
                    variant="ghost"
                    className="min-h-[44px] sm:min-h-[36px]"
                    disabled={emAndamento}
                    onClick={() => recusar.mutate(c)}
                  >
                    Recusar
                  </Button>
                  <Button
                    size="sm"
                    className="min-h-[44px] sm:min-h-[36px]"
                    disabled={emAndamento}
                    onClick={() => aceitar.mutate(c.id)}
                  >
                    {aceitar.isPending && aceitar.variables === c.id && <Spinner size={16} className="mr-2 text-inherit" />}
                    Aceitar
                  </Button>
                </span>
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
